import React from "react";
import "./AppHome.css";

function LogoFullPage() {
  return (
    <div className="main-photo-container">
      <img
        src={`${process.env.PUBLIC_URL}/Images/logo.jpeg`}
        alt="Logo"
        className="logo-full"
      />
    </div>
  );
}

export default LogoFullPage;
